import React, { useEffect, useState, useRef } from 'react'
import { AiFillEyeInvisible, AiFillEye } from 'react-icons/ai'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import getAuth, {
  useAuth,
  signIn,
  signIn2,
  updatePassword,
} from '../hooks/getAuth'
import ImageHead from '../assets/svg/hydra_score_head_sm.webp'
import { confirmable, createConfirmation } from 'react-confirm'

import AuthCode from 'react-auth-code-input'
import '../factor.css'
import Spinner from '../components/Spinner'
import { FaLinkedinIn, FaYoutube, FaFacebookF } from 'react-icons/fa'
import { callAPI } from '../hooks/api'
import DeleteAccount from '../components/DeleteAccount'

export default function SignIn({ freshRestart, currentTab, setCurrentTab }) {
  setCurrentTab('delete')
  const removeStylesheet = (href) => {
    const link = document.querySelector(`link[href="${href}"]`)
    if (link) {
      document.body.removeChild(link)
    }
  }
  removeStylesheet('/css/landing.css')
  removeStylesheet('/css/bootstrap.css')
  const { setAuth, isLoggedIn, setIsLoggedIn } = useAuth()
  const [loading, setLoading] = useState(false)

  const [showPassword, setShowPassword] = useState(false)
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()

  const [deletePage, setDeletePage] = useState(false)
  const [otpPage, setOtpPage] = useState(false)
  const [passwordUpdate, setPasswordUpdate] = useState(false)
  const [otp, setOtp] = useState('')
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    newPassword: '',
    confirmPassword: '',
  })

  const confirm = createConfirmation(DeleteAccount)
  const { email, password, newPassword, confirmPassword } = formData
  const navigate = useNavigate()

  const AuthInputRef = useRef(null)
  const handleOnChange = (res) => {
    setOtp(res)
  }

  function onChange(e) {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }))
  }

  async function signInWithEmailAndPasswordAndOtp() {
    if (!email || !password || !otp) {
      throw new Error('One or more required fields are empty.')
    }
    // API call to create user
    return await getAuth(email, password, otp)
  }

  const handleIconClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  async function onSubmit(e) {
    e.preventDefault()

    // Show a confirmation dialog before proceeding

    const proceed = await confirm({
      confirmation: `You are about to permanently delete you data. THIS CANNOT BE UNDONE.`,
    })

    if (proceed) {
      try {
        callAPI('/delete_account', {
          email: email,
          password,
        }).then((res) => {
          if (res.status === 'success') {
            toast.success(res.msg)
            localStorage.setItem('auth', JSON.stringify({}))
            freshRestart()
            navigate('/', { replace: true })
          } else {
            toast.warn(res.msg)
          }
        })
      } catch (error) {
        toast.warn(error.message)
      }
    }
  }
  async function onSubmitUpdate(e) {
    e.preventDefault()
    if (newPassword !== confirmPassword) {
      toast.warn('Your passwords do not match.')
      return
    }
    try {
      const userCredential = await updatePassword(email, password, newPassword)
      toast.dismiss()
      if (userCredential.sessionKey) {
        localStorage.setItem('auth', JSON.stringify(userCredential))
        setAuth(userCredential)
        setIsLoggedIn(true)
        setDeletePage(true)
      } else if (userCredential.status === 'fail') {
        toast.warn(userCredential.msg)
      } else if (userCredential.status === 'update') {
        toast.warn('Please update your password!', { autoClose: false })
        setPasswordUpdate(true)
      }
    } catch (error) {
      toast.warn(error.message)
    }
  }

  async function onSubmitOtp(e) {
    e.preventDefault()
    try {
      const userCredential = await signInWithEmailAndPasswordAndOtp()
      if (userCredential.sessionKey) {
        localStorage.setItem('auth', JSON.stringify(userCredential))
        setAuth(userCredential)
        setIsLoggedIn(true)
        navigate(
          searchParams.get('locations')
            ? `/?locations=${searchParams.get('locations')}`
            : '/',
          { replace: true }
        )
      } else if (userCredential.status === 'fail') {
        toast.warn(userCredential.msg)
      }
    } catch (error) {
      toast.warn(error.message)
    }
  }

  useEffect(() => {
    if (isLoggedIn) setDeletePage(true)
  }, [isLoggedIn])
  useEffect(() => {
    freshRestart()
  }, [])

  if (otpPage) {
    return (
      <section className="splash-icon" style={{ minHeight: '770px' }}>
        {loading && <Spinner />}
        <div className="signin-box">
          <div className="flex justify-center flex-wrap items-center px-6 py-12 max-w-2xl mx-auto bg-white rounded">
            <div className="w-full md:w-[87%] lg:w-[72%]">
              <div
                className="items-center w-full flex flex-col"
                style={{ padding: '1em 1em' }}
              >
                <img src={ImageHead} alt="Head" />
                <h1 className="text-3xl text-center mb-10 font-bold">
                  Update Password
                </h1>
              </div>
              <form onSubmit={onSubmitUpdate}>
                <input
                  className="mb-6 w-full px-4 py-2 text-xl text-gray-700 bg-white border-gray-300 rounded transition ease-in-out"
                  type="text"
                  id="email"
                  value={email}
                  onChange={onChange}
                  placeholder="Email"
                />
                <div className="relative mb-6">
                  <input
                    className="w-full px-4 py-2 text-xl text-gray-700 bg-white border-gray-300 rounded transition ease-in-out"
                    type={showNewPassword ? 'text' : 'password'}
                    id="newPassword"
                    value={newPassword}
                    onChange={onChange}
                    placeholder="New Password"
                    style={
                      newPassword === confirmPassword
                        ? {}
                        : { backgroundColor: '#fb9a9a' }
                    }
                  />
                  {showNewPassword ? (
                    <AiFillEyeInvisible
                      className="absolute right-3 top-3 text-xl cursor-pointer"
                      onClick={() =>
                        setShowNewPassword((prevState) => !prevState)
                      }
                    />
                  ) : (
                    <AiFillEye
                      className="absolute right-3 top-3 text-xl cursor-pointer"
                      onClick={() =>
                        setShowNewPassword((prevState) => !prevState)
                      }
                    />
                  )}
                </div>
                <div className="relative mb-6">
                  <input
                    className="w-full px-4 py-2 text-xl text-gray-700 bg-white border-gray-300 rounded transition ease-in-out"
                    type={showConfirmPassword ? 'text' : 'password'}
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={onChange}
                    placeholder="Confirm New Password"
                    style={
                      newPassword === confirmPassword
                        ? {}
                        : { backgroundColor: '#fb9a9a' }
                    }
                  />
                  {showConfirmPassword ? (
                    <AiFillEyeInvisible
                      className="absolute right-3 top-3 text-xl cursor-pointer"
                      onClick={() =>
                        setShowConfirmPassword((prevState) => !prevState)
                      }
                    />
                  ) : (
                    <AiFillEye
                      className="absolute right-3 top-3 text-xl cursor-pointer"
                      onClick={() =>
                        setShowConfirmPassword((prevState) => !prevState)
                      }
                    />
                  )}
                </div>
                <button
                  className="w-full bg-primary text-white px-7 py-3 text-sm font-medium uppercase rounded shadow-md hover:bg-[#01589d] transition duration-150 ease-in-out hover:shadow-lg active:bg-primary mb-3"
                  type="submit"
                >
                  Update Password
                </button>
              </form>
            </div>
          </div>
          <div className="mt-6 text-center">
            <p className="text-gray-400 mb-4">
              Hydra score™ is a precision water and land data analytics
              platform.
            </p>
            <div className="flex justify-center space-x-4">
              <FaFacebookF
                style={{
                  width: '20px',
                  height: '20px',
                  color: 'gray',
                  cursor: 'pointer',
                  borderRadius: '4px',
                }}
                onClick={() =>
                  handleIconClick(
                    'https://www.facebook.com/profile.php?id=61560861611781'
                  )
                }
              />
              <FaYoutube
                style={{
                  width: '20px',
                  height: '20px',
                  color: 'gray',
                  cursor: 'pointer',
                  borderRadius: '4px',
                }}
                onClick={() =>
                  handleIconClick(
                    'https://www.youtube.com/channel/UCOfzLw8uh-KvxDKqDjsmBzA'
                  )
                }
              />
              <FaLinkedinIn
                style={{
                  width: '20px',
                  height: '20px',
                  color: 'gray',
                  cursor: 'pointer',
                  borderRadius: '4px',
                }}
                onClick={() =>
                  handleIconClick(
                    'https://www.linkedin.com/company/hydra-score/about/?viewAsMember=true'
                  )
                }
              />
            </div>
          </div>
        </div>
      </section>
    )
  } else {
    return (
      <section className="splash-icon" style={{ minHeight: '770px' }}>
        {loading && <Spinner />}
        <div className="delete-box">
          <div className="flex justify-center flex-wrap items-center px-6 py-12 max-w-2xl mx-auto bg-white rounded">
            <div className="w-full md:w-[87%] lg:w-[72%]">
              <div
                className="items-center w-full flex flex-col"
                style={{ padding: '1em 1em' }}
              >
                <img src={ImageHead} alt="Head" />
                <h1 className="text-3xl text-center mb-10 font-bold">
                  Delete Your Hydra score™ Account
                </h1>
              </div>
              <p className="text-center mb-4 text-gray-600">
                To permanently delete your account, please sign in and confirm.
                Deleting your account will remove all personal data associated
                with your account, except data required to meet legal
                obligations.
              </p>
              <form onSubmit={onSubmit}>
                <input
                  className="mb-3 w-full px-4 py-2 text-xl text-gray-700 bg-white border-gray-300 rounded transition ease-in-out"
                  type="email"
                  id="email"
                  value={email}
                  onChange={onChange}
                  placeholder="Email"
                />
                <div className="relative mb-3">
                  <input
                    className="w-full px-4 py-2 text-xl text-gray-700 bg-white border-gray-300 rounded transition ease-in-out"
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    value={password}
                    onChange={onChange}
                    placeholder="Password"
                  />
                  {showPassword ? (
                    <AiFillEyeInvisible
                      className="absolute right-3 top-3 text-xl cursor-pointer"
                      onClick={() => setShowPassword((prevState) => !prevState)}
                    />
                  ) : (
                    <AiFillEye
                      className="absolute right-3 top-3 text-xl cursor-pointer"
                      onClick={() => setShowPassword((prevState) => !prevState)}
                    />
                  )}
                </div>
                <button
                  className="w-full bg-red-600 text-white px-7 py-3 text-sm font-medium uppercase rounded shadow-md hover:bg-red-700 transition duration-150 ease-in-out hover:shadow-lg active:bg-red-800 mb-3"
                  type="submit"
                >
                  Confirm Account Deletion
                </button>
                <hr className="my-6" />
                <p className="text-center text-gray-700 mb-6">
                  By deleting your account, the following data will be
                  permanently removed: account information, ranches created, and
                  activity logs.
                </p>
                <button
                  className="w-full bg-gray-200 text-gray-700 px-7 py-3 text-sm font-medium uppercase rounded shadow-md hover:bg-gray-300 transition duration-150 ease-in-out hover:shadow-lg active:bg-gray-400"
                  onClick={() => navigate('/', { replace: true })}
                >
                  Back to Landing Page
                </button>
              </form>
            </div>
          </div>
          <div className="mt-6 text-center">
            <p className="text-gray-400 mb-4">
              Hydra score™ is a precision water and land data analytics
              platform.
            </p>
            <div className="flex justify-center space-x-4">
              <FaFacebookF
                style={{
                  width: '20px',
                  height: '20px',
                  color: 'gray',
                  cursor: 'pointer',
                  borderRadius: '4px',
                }}
                onClick={() =>
                  handleIconClick(
                    'https://www.facebook.com/profile.php?id=61560861611781'
                  )
                }
              />
              <FaYoutube
                style={{
                  width: '20px',
                  height: '20px',
                  color: 'gray',
                  cursor: 'pointer',
                  borderRadius: '4px',
                }}
                onClick={() =>
                  handleIconClick(
                    'https://www.youtube.com/channel/UCOfzLw8uh-KvxDKqDjsmBzA'
                  )
                }
              />
              <FaLinkedinIn
                style={{
                  width: '20px',
                  height: '20px',
                  color: 'gray',
                  cursor: 'pointer',
                  borderRadius: '4px',
                }}
                onClick={() =>
                  handleIconClick(
                    'https://www.linkedin.com/company/hydra-score/about/?viewAsMember=true'
                  )
                }
              />
            </div>
          </div>
        </div>
      </section>
    )
  }
}
